/* eslint-disable */
    /*!
    * Copyright (c) Microsoft Corporation.
    * All rights reserved. See LICENSE in the project root for license information.
    * THIS FILE IS AN AUTOGENERATED TYPESCRIPT PROXY EXTENSION.
    * TO USE THIS FILE, IT MUST BE ADDED TO A D365COMMERCE APPLICATION
    */
    import {
        AsyncResult,
        callActionOrExecute,
        DataServiceQuery,
        IContext,
        IDataServiceRequest,
        IQueryResultSettings,
        // @ts-ignore -- Unused import
        NullResult
    } from '@msdyn365-commerce/retail-proxy';
    // @ts-ignore -- Unused import
    import * as EntityClasses from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g';
    // @ts-ignore -- Unused import
    import * as Entities from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceTypes.g';
    import * as DataServiceEntities from './DataServiceEntities.g';

    
    function customerMatchQuery(): DataServiceQuery {
          return new DataServiceQuery();
          }

    
    export function customerMatchInput (
        customerMatchCriteria:
            DataServiceEntities.ICustomerMatchCriteria
    ): IDataServiceRequest {
      const query = customerMatchQuery();
      return query.createDataServiceRequestForOperation(
          'CustomerMatch',
          true, 
            DataServiceEntities.CustomResponse_1OfCustomerMatchResultExtensionClass
          ,
          'false',
          { bypassCache: 'get', returnEntity: 'DataServiceEntities.ICustomResponse_1OfCustomerMatchResult' },
          {
          customerMatchCriteria: customerMatchCriteria
          }
      );
    }

    export function customerMatchAsync (
        context: IContext, customerMatchCriteria:
            DataServiceEntities.ICustomerMatchCriteria
        ): AsyncResult<DataServiceEntities.ICustomResponse_1OfCustomerMatchResult> {
        const request = customerMatchInput(customerMatchCriteria);
        return callActionOrExecute<DataServiceEntities.ICustomResponse_1OfCustomerMatchResult>(request, context.callerContext);
        }
      
    function setCustomerMatchEmailQuery(): DataServiceQuery {
          return new DataServiceQuery();
          }

    
    export function setCustomerMatchEmailInput (
        setEmailInfo:
            DataServiceEntities.ICustomerMatchEmailInformation
    ): IDataServiceRequest {
      const query = setCustomerMatchEmailQuery();
      return query.createDataServiceRequestForOperation(
          'SetCustomerMatchEmail',
          true, 
            DataServiceEntities.CustomResponse_1OfBooleanExtensionClass
          ,
          'false',
          { bypassCache: 'get', returnEntity: 'DataServiceEntities.ICustomResponse_1OfBoolean' },
          {
          setEmailInfo: setEmailInfo
          }
      );
    }

    export function setCustomerMatchEmailAsync (
        context: IContext, setEmailInfo:
            DataServiceEntities.ICustomerMatchEmailInformation
        ): AsyncResult<DataServiceEntities.ICustomResponse_1OfBoolean> {
        const request = setCustomerMatchEmailInput(setEmailInfo);
        return callActionOrExecute<DataServiceEntities.ICustomResponse_1OfBoolean>(request, context.callerContext);
        }
      

        // @ts-ignore
        function loyaltyExtensionQuery(id?: number): DataServiceQuery {
        const key = (id) ? { Id: id } :null;
        return new DataServiceQuery("LoyaltyExtension", "LoyaltyTierRulesEntity", DataServiceEntities.LoyaltyTierRulesEntityExtensionClass, key);
        }

        
    export function createGetLoyaltyTierRulesInput(queryResultSettings: IQueryResultSettings, rewardPointId: string): IDataServiceRequest {
    const query = loyaltyExtensionQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation('GetLoyaltyTierRules', true, DataServiceEntities.LoyaltyTierRulesEntityExtensionClass, 'true', {bypassCache: 'none', returnEntity: 'DataServiceEntities.ILoyaltyTierRulesEntity'}, {rewardPointId: rewardPointId });
    }

    
    export function getLoyaltyTierRulesAsync(context: IContext, rewardPointId: string): AsyncResult<DataServiceEntities.ILoyaltyTierRulesEntity[]> {
    const request = createGetLoyaltyTierRulesInput(
      context.queryResultSettings || {}, rewardPointId);
    return callActionOrExecute<DataServiceEntities.ILoyaltyTierRulesEntity[]>(request, context.callerContext);
    }
  